/**
 * Parse commonly used html tags.
 * */
export const parseTags = {
  b: (...chunks: React.ReactNode[]) => <b>{chunks}</b>,
  i: (...chunks: React.ReactNode[]) => <i>{chunks}</i>,
  small: (...chunks: React.ReactNode[]) => <small>{chunks}</small>,
  br: <br />
}
